import ComboLeaf from '@/services/five-card-hands/five-card-hand-leaf/ComboLeaf';
import ComboParent from '@/services/five-card-hands/five-card-hand-parent/ComboParent';
import FiveCardHandsCategory from '@/services/five-card-hands/categories/FiveCardHandsCategory';

export default class Combos extends FiveCardHandsCategory {
  constructor () {
    super();
    this.data = [
      new ComboParent({
        id: 'tpwkPlusAnd',
        text: '<abbr title="Top pair weak kicker">TPWK</abbr>+',
        fullText: '<abbr title="Top pair weak kicker">TPWK</abbr>+',
        isAHit: function (handInfo, drawInfo) {
          let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
          let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
          let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
          let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
          let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
          let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

          return (
            (handInfo.id === 'pair:overpair' && (flushDraw || eightOutStraightDraw || gutshot || backdoorFlushDraw || backdoorStraightDraw)) ||
            (handInfo.id === 'pair:tptk' && (flushDraw || eightOutStraightDraw || gutshot || oneOvercard || backdoorFlushDraw || backdoorStraightDraw)) ||
            (handInfo.id === 'pair:tpgk' && (flushDraw || eightOutStraightDraw || gutshot || oneOvercard || backdoorFlushDraw || backdoorStraightDraw)) ||
            (handInfo.id === 'pair:tpwk' && (flushDraw || eightOutStraightDraw || gutshot || oneOvercard || backdoorFlushDraw || backdoorStraightDraw))
          );
        },
        children: [
          new ComboParent({
            id: 'tpwkPlusAnd:overpairAnd',
            text: 'Overpair and&hellip;',
            fullText: 'Overpair and&hellip;',
            isAHit: function (handInfo, drawInfo) {
              let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
              let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
              let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
              let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
              let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
              let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

              return (
                handInfo.id === 'pair:overpair' &&
                (flushDraw || eightOutStraightDraw || gutshot || backdoorFlushDraw || backdoorStraightDraw)
              );
            },
            children: [
              new ComboLeaf({
                id: 'tpwkPlusAnd:overpairAnd:flushDraw',
                text: '&hellip;flush draw',
                fullText: 'Overpair and flush draw',
                isAHit: function (handInfo, drawInfo) {
                  let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';

                  return handInfo.id === 'pair:overpair' && flushDraw;
                },
              }),
              new ComboLeaf({
                id: 'tpwkPlusAnd:overpairAnd:eightOutStraightDraw',
                text: '&hellip;<abbr title="Eight out straight draw">8OSD</abbr>',
                fullText: 'Overpair and eight out straight draw',
                isAHit: function (handInfo, drawInfo) {
                  let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');

                  return handInfo.id === 'pair:overpair' && eightOutStraightDraw;
                },
              }),
              new ComboLeaf({
                id: 'tpwkPlusAnd:overpairAnd:gutshot',
                text: '&hellip;gutshot',
                fullText: 'Overpair and gutshot',
                isAHit: function (handInfo, drawInfo) {
                  let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';

                  return handInfo.id === 'pair:overpair' && gutshot;
                },
              }),
              new ComboLeaf({
                id: 'tpwkPlusAnd:overpairAnd:backdoorFlushDraw',
                text: '&hellip;<abbr title="Backdoor flush draw">bckdr fl dr</abbr>',
                fullText: 'Overpair and backdoor flush draw',
                isAHit: function (handInfo, drawInfo) {
                  let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

                  return handInfo.id === 'pair:overpair' && backdoorFlushDraw;
                },
              }),
              new ComboLeaf({
                id: 'tpwkPlusAnd:overpairAnd:backdoorStraightDraw',
                text: '&hellip;<abbr title="Backdoor straight draw">bckdr str dr</abbr>',
                fullText: 'Overpair and backdoor straight draw',
                isAHit: function (handInfo, drawInfo) {
                  let backdoorStraightDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

                  return handInfo.id === 'pair:overpair' && backdoorStraightDraw;
                },
              }),
            ],
          }),
          new ComboParent({
            id: 'tpwkPlusAnd:tptkAnd',
            text: '<abbr title="Top pair top kicker">TPTK</abbr> and&hellip;',
            fullText: '<abbr title="Top pair top kicker">TPTK</abbr> and&hellip;',
            isAHit: function (handInfo, drawInfo) {
              let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
              let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
              let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
              let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
              let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
              let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

              return (
                handInfo.id === 'pair:tptk' &&
                (flushDraw || eightOutStraightDraw || gutshot || oneOvercard || backdoorFlushDraw || backdoorStraightDraw)
              );
            },
            children: [
              new ComboLeaf({
                id: 'tpwkPlusAnd:tptkAnd:flushDraw',
                text: '&hellip;flush draw',
                fullText: 'TPTK and flush draw',
                isAHit: function (handInfo, drawInfo) {
                  let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';

                  return handInfo.id === 'pair:tptk' && flushDraw;
                },
              }),
              new ComboLeaf({
                id: 'tpwkPlusAnd:tptkAnd:eightOutStraightDraw',
                text: '&hellip;<abbr title="Eight out straight draw">8OSD</abbr>',
                fullText: 'TPTK and eight out straight draw',
                isAHit: function (handInfo, drawInfo) {
                  let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');

                  return handInfo.id === 'pair:tptk' && eightOutStraightDraw;
                },
              }),
              new ComboLeaf({
                id: 'tpwkPlusAnd:tptkAnd:gutshot',
                text: '&hellip;gutshot',
                fullText: 'TPTK and gutshot',
                isAHit: function (handInfo, drawInfo) {
                  let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';

                  return handInfo.id === 'pair:tptk' && gutshot;
                },
              }),
              new ComboLeaf({
                id: 'tpwkPlusAnd:tptkAnd:oneOvercard',
                text: '&hellip;1 overcard',
                fullText: 'TPTK and one overcard',
                isAHit: function (handInfo, drawInfo) {
                  let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

                  return handInfo.id === 'pair:tptk' && oneOvercard;
                },
              }),
              new ComboLeaf({
                id: 'tpwkPlusAnd:tptkAnd:backdoorFlushDraw',
                text: '&hellip;<abbr title="Backdoor flush draw">bckdr fl dr</abbr>',
                fullText: 'TPTK and backdoor flush draw',
                isAHit: function (handInfo, drawInfo) {
                  let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

                  return handInfo.id === 'pair:tptk' && backdoorFlushDraw;
                },
              }),
              new ComboLeaf({
                id: 'tpwkPlusAnd:tptkAnd:backdoorStraightDraw',
                text: '&hellip;<abbr title="Backdoor straight draw">bckdr str dr</abbr>',
                fullText: 'TPTK and backdoor straight draw',
                isAHit: function (handInfo, drawInfo) {
                  let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

                  return handInfo.id === 'pair:tptk' && backdoorStraightDraw;
                },
              }),
            ],
          }),
          new ComboParent({
            id: 'tpwkPlusAnd:tpgkAnd',
            text: '<abbr title="Top pair good kicker">TPGK</abbr> and&hellip;',
            fullText: '<abbr title="Top pair good kicker">TPGK</abbr> and&hellip;',
            isAHit: function (handInfo, drawInfo) {
              let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
              let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
              let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
              let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
              let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
              let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

              return (
                handInfo.id === 'pair:tpgk' &&
                (flushDraw || eightOutStraightDraw || gutshot || oneOvercard || backdoorFlushDraw || backdoorStraightDraw)
              );
            },
            children: [
              new ComboLeaf({
                id: 'tpwkPlusAnd:tpgkAnd:flushDraw',
                text: '&hellip;flush draw',
                fullText: 'TPGK and flush draw',
                isAHit: function (handInfo, drawInfo) {
                  let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';

                  return handInfo.id === 'pair:tpgk' && flushDraw;
                },
              }),
              new ComboLeaf({
                id: 'tpwkPlusAnd:tpgkAnd:eightOutStraightDraw',
                text: '&hellip;<abbr title="Eight out straight draw">8OSD</abbr>',
                fullText: 'TPGK and eight out straight draw',
                isAHit: function (handInfo, drawInfo) {
                  let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');

                  return handInfo.id === 'pair:tpgk' && eightOutStraightDraw;
                },
              }),
              new ComboLeaf({
                id: 'tpwkPlusAnd:tpgkAnd:gutshot',
                text: '&hellip;gutshot',
                fullText: 'TPGK and gutshot',
                isAHit: function (handInfo, drawInfo) {
                  let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';

                  return handInfo.id === 'pair:tpgk' && gutshot;
                },
              }),
              new ComboLeaf({
                id: 'tpwkPlusAnd:tpgkAnd:oneOvercard',
                text: '&hellip;1 overcard',
                fullText: 'TPGK and one overcard',
                isAHit: function (handInfo, drawInfo) {
                  let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

                  return handInfo.id === 'pair:tpgk' && oneOvercard;
                },
              }),
              new ComboLeaf({
                id: 'tpwkPlusAnd:tpgkAnd:backdoorFlushDraw',
                text: '&hellip;<abbr title="Backdoor flush draw">bckdr fl dr</abbr>',
                fullText: 'TPGK and backdoor flush draw',
                isAHit: function (handInfo, drawInfo) {
                  let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

                  return handInfo.id === 'pair:tpgk' && backdoorFlushDraw;
                },
              }),
              new ComboLeaf({
                id: 'tpwkPlusAnd:tpgkAnd:backdoorStraightDraw',
                text: '&hellip;<abbr title="Backdoor straight draw">bckdr str dr</abbr>',
                fullText: 'TPGK and backdoor straight draw',
                isAHit: function (handInfo, drawInfo) {
                  let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

                  return handInfo.id === 'pair:tpgk' && backdoorStraightDraw;
                },
              }),
            ],
          }),
          new ComboParent({
            id: 'tpwkPlusAnd:tpwkAnd',
            text: '<abbr title="Top pair weak kicker">TPWK</abbr> and&hellip;',
            fullText: '<abbr title="Top pair weak kicker">TPWK</abbr> and&hellip;',
            isAHit: function (handInfo, drawInfo) {
              let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
              let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
              let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
              let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
              let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
              let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

              return (
                handInfo.id === 'pair:tpwk' &&
                (flushDraw || eightOutStraightDraw || gutshot || oneOvercard || backdoorFlushDraw || backdoorStraightDraw)
              );
            },
            children: [
              new ComboLeaf({
                id: 'tpwkPlusAnd:tpwkAnd:flushDraw',
                text: '&hellip;flush draw',
                fullText: 'TPWK and flush draw',
                isAHit: function (handInfo, drawInfo) {
                  let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';

                  return handInfo.id === 'pair:tpwk' && flushDraw;
                },
              }),
              new ComboLeaf({
                id: 'tpwkPlusAnd:tpwkAnd:eightOutStraightDraw',
                text: '&hellip;<abbr title="Eight out straight draw">8OSD</abbr>',
                fullText: 'TPWK and eight out straight draw',
                isAHit: function (handInfo, drawInfo) {
                  let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');

                  return handInfo.id === 'pair:tpwk' && eightOutStraightDraw;
                },
              }),
              new ComboLeaf({
                id: 'tpwkPlusAnd:tpwkAnd:gutshot',
                text: '&hellip;gutshot',
                fullText: 'TPWK and gutshot',
                isAHit: function (handInfo, drawInfo) {
                  let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';

                  return handInfo.id === 'pair:tpwk' && gutshot;
                },
              }),
              new ComboLeaf({
                id: 'tpwkPlusAnd:tpwkAnd:oneOvercard',
                text: '&hellip;1 overcard',
                fullText: 'TPWK and one overcard',
                isAHit: function (handInfo, drawInfo) {
                  let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

                  return handInfo.id === 'pair:tpwk' && oneOvercard;
                },
              }),
              new ComboLeaf({
                id: 'tpwkPlusAnd:tpwkAnd:backdoorFlushDraw',
                text: '&hellip;<abbr title="Backdoor flush draw">bckdr fl dr</abbr>',
                fullText: 'TPWK and backdoor flush draw',
                isAHit: function (handInfo, drawInfo) {
                  let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

                  return handInfo.id === 'pair:tpwk' && backdoorFlushDraw;
                },
              }),
              new ComboLeaf({
                id: 'tpwkPlusAnd:tpwkAnd:backdoorStraightDraw',
                text: '&hellip;<abbr title="Backdoor straight draw">bckdr str dr</abbr>',
                fullText: 'TPWK and backdoor straight draw',
                isAHit: function (handInfo, drawInfo) {
                  let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

                  return handInfo.id === 'pair:tpwk' && backdoorStraightDraw;
                },
              }),
            ],
          }),
        ],
      }),
      new ComboParent({
        id: 'middlePairPlusAnd',
        text: 'Middle pair+',
        fullText: 'Middle pair+',
        isAHit: function (handInfo, drawInfo) {
          let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
          let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
          let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
          let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
          let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
          let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

          return (
            (handInfo.id === 'pair:ppUnderTp' && (flushDraw || eightOutStraightDraw || gutshot || backdoorFlushDraw || backdoorStraightDraw)) ||
            (handInfo.id === 'pair:secondPair' && (flushDraw || eightOutStraightDraw || gutshot || oneOvercard)) ||
            (handInfo.id === 'pair:middlePair' && (flushDraw || eightOutStraightDraw || gutshot || oneOvercard || backdoorFlushDraw || backdoorStraightDraw))
          );
        },
        children: [
          new ComboParent({
            id: 'middlePairPlusAnd:ppUnderTpAnd',
            text: '<abbr title="Pocket pair under top pair">PP under TP</abbr> and&hellip;',
            fullText: '<abbr title="Pocket pair under top pair">PP under TP</abbr> and&hellip;',
            isAHit: function (handInfo, drawInfo) {
              let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
              let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
              let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
              let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
              let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
              let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

              return (
                handInfo.id === 'pair:ppUnderTp' &&
                (flushDraw || eightOutStraightDraw || gutshot || backdoorFlushDraw || backdoorStraightDraw)
              );
            },
            children: [
              new ComboLeaf({
                id: 'middlePairPlusAnd:ppUnderTpAnd:flushDraw',
                text: '&hellip;flush draw',
                fullText: 'PP under TP and flush draw',
                isAHit: function (handInfo, drawInfo) {
                  let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';

                  return (handInfo.id === 'pair:ppUnderTp' && flushDraw);
                },
              }),
              new ComboLeaf({
                id: 'middlePairPlusAnd:ppUnderTpAnd:eightOutStraightDraw',
                text: '&hellip;<abbr title="Eight out straight draw">8OSD</abbr>',
                fullText: 'PP under TP and eight out straight draw',
                isAHit: function (handInfo, drawInfo) {
                  let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');

                  return (handInfo.id === 'pair:ppUnderTp' && eightOutStraightDraw);
                },
              }),
              new ComboLeaf({
                id: 'middlePairPlusAnd:ppUnderTpAnd:gutshot',
                text: '&hellip;gutshot',
                fullText: 'PP under TP and gutshot',
                isAHit: function (handInfo, drawInfo) {
                  let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';

                  return (handInfo.id === 'pair:ppUnderTp' && gutshot);
                },
              }),
              new ComboLeaf({
                id: 'middlePairPlusAnd:ppUnderTpAnd:backdoorFlushDraw',
                text: '&hellip;<abbr title="Backdoor flush draw">bckdr fl dr</abbr>',
                fullText: 'PP under TP and backdoor flush draw',
                isAHit: function (handInfo, drawInfo) {
                  let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

                  return (handInfo.id === 'pair:ppUnderTp' && backdoorFlushDraw);
                },
              }),
              new ComboLeaf({
                id: 'middlePairPlusAnd:ppUnderTpAnd:backdoorStraightDraw',
                text: '&hellip;<abbr title="Backdoor straight draw">bckdr str dr</abbr>',
                fullText: 'PP under TP and backdoor straight draw',
                isAHit: function (handInfo, drawInfo) {
                  let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

                  return (handInfo.id === 'pair:ppUnderTp' && backdoorStraightDraw);
                },
              }),
            ],
          }),
          new ComboParent({
            id: 'middlePairPlusAnd:secondPairAnd',
            text: 'Second pair and&hellip;',
            fullText: 'Second pair and&hellip;',
            isAHit: function (handInfo, drawInfo) {
              let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
              let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
              let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
              let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
              let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
              let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

              return (
                handInfo.id === 'pair:secondPair' &&
                (flushDraw || eightOutStraightDraw || gutshot || oneOvercard)
              );
            },
            children: [
              new ComboLeaf({
                id: 'middlePairPlusAnd:secondPairAnd:flushDraw',
                text: '&hellip;flush draw',
                fullText: 'Second pair and flush draw',
                isAHit: function (handInfo, drawInfo) {
                  let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';

                  return (handInfo.id === 'pair:secondPair' && flushDraw);
                },
              }),
              new ComboLeaf({
                id: 'middlePairPlusAnd:secondPairAnd:eightOutStraightDraw',
                text: '&hellip;<abbr title="Eight out straight draw">8OSD</abbr>',
                fullText: 'Second pair and eight out straight draw',
                isAHit: function (handInfo, drawInfo) {
                  let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');

                  return (handInfo.id === 'pair:secondPair' && eightOutStraightDraw);
                },
              }),
              new ComboLeaf({
                id: 'middlePairPlusAnd:secondPairAnd:gutshot',
                text: '&hellip;gutshot',
                fullText: 'Second pair and gutshot',
                isAHit: function (handInfo, drawInfo) {
                  let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';

                  return (handInfo.id === 'pair:secondPair' && gutshot);
                },
              }),
              new ComboLeaf({
                id: 'middlePairPlusAnd:secondPairAnd:oneOvercard',
                text: '&hellip;1 overcard',
                fullText: 'Second pair and one overcard',
                isAHit: function (handInfo, drawInfo) {
                  let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

                  return (handInfo.id === 'pair:secondPair' && oneOvercard);
                },
              }),
            ],
          }),
          new ComboParent({
            id: 'middlePairPlusAnd:middlePairAnd',
            text: 'Middle pair and&hellip;',
            fullText: 'Middle pair and&hellip;',
            isAHit: function (handInfo, drawInfo) {
              let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
              let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
              let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
              let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
              let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
              let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

              return (
                handInfo.id === 'pair:middlePair' &&
                (flushDraw || eightOutStraightDraw || gutshot || oneOvercard || backdoorFlushDraw || backdoorStraightDraw)
              );
            },
            children: [
              new ComboLeaf({
                id: 'middlePairPlusAnd:middlePairAnd:flushDraw',
                text: '&hellip;flush draw',
                fullText: 'Middle pair and flush draw',
                isAHit: function (handInfo, drawInfo) {
                  let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';

                  return (handInfo.id === 'pair:middlePair' && flushDraw);
                },
              }),
              new ComboLeaf({
                id: 'middlePairPlusAnd:middlePairAnd:eightOutStraightDraw',
                text: '&hellip;<abbr title="Eight out straight draw">8OSD</abbr>',
                fullText: 'Middle pair and eight out straight draw',
                isAHit: function (handInfo, drawInfo) {
                  let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');

                  return (handInfo.id === 'pair:middlePair' && eightOutStraightDraw);
                },
              }),
              new ComboLeaf({
                id: 'middlePairPlusAnd:middlePairAnd:gutshot',
                text: '&hellip;gutshot',
                fullText: 'Middle pair and gutshot',
                isAHit: function (handInfo, drawInfo) {
                  let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';

                  return (handInfo.id === 'pair:middlePair' && gutshot);
                },
              }),
              new ComboLeaf({
                id: 'middlePairPlusAnd:middlePairAnd:oneOvercard',
                text: '&hellip;1 overcard',
                fullText: 'Middle pair and one overcard',
                isAHit: function (handInfo, drawInfo) {
                  let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

                  return (handInfo.id === 'pair:middlePair' && oneOvercard);
                },
              }),
              new ComboLeaf({
                id: 'middlePairPlusAnd:middlePairAnd:backdoorFlushDraw',
                text: '&hellip;<abbr title="Backdoor flush draw">bckdr fl dr</abbr>',
                fullText: 'Middle pair and backdoor flush draw',
                isAHit: function (handInfo, drawInfo) {
                  let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

                  return (handInfo.id === 'pair:middlePair' && backdoorFlushDraw);
                },
              }),
              new ComboLeaf({
                id: 'middlePairPlusAnd:middlePairAnd:backdoorStraightDraw',
                text: '&hellip;<abbr title="Backdoor straight draw">bckdr str dr</abbr>',
                fullText: 'Middle pair and backdoor straight draw',
                isAHit: function (handInfo, drawInfo) {
                  let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

                  return (handInfo.id === 'pair:middlePair' && backdoorStraightDraw);
                },
              }),
            ],
          }),
        ],
      }),
      new ComboParent({
        id: 'weakPairAnd',
        text: 'Weak pair and&hellip;',
        fullText: 'Weak pair and&hellip;',
        isAHit: function (handInfo, drawInfo) {
          let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
          let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
          let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
          let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
          let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
          let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

          return (
            handInfo.id === 'pair:weakPair' &&
            (flushDraw || eightOutStraightDraw || gutshot || oneOvercard || backdoorFlushDraw || backdoorStraightDraw)
          );
        },
        children: [
          new ComboLeaf({
            id: 'weakPairAnd:flushDraw',
            text: '&hellip;flush draw',
            fullText: 'Weak pair and flush draw',
            isAHit: function (handInfo, drawInfo) {
              let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';

              return handInfo.id === 'pair:weakPair' && flushDraw;
            },
          }),
          new ComboLeaf({
            id: 'weakPairAnd:eightOutStraightDraw',
            text: '&hellip;<abbr title="Eight out straight draw">8OSD</abbr>',
            fullText: 'Weak pair and eight out straight draw',
            isAHit: function (handInfo, drawInfo) {
              let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');

              return handInfo.id === 'pair:weakPair' && eightOutStraightDraw;
            },
          }),
          new ComboLeaf({
            id: 'weakPairAnd:gutshot',
            text: '&hellip;gutshot',
            fullText: 'Weak pair and gutshot',
            isAHit: function (handInfo, drawInfo) {
              let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';

              return handInfo.id === 'pair:weakPair' && gutshot;
            },
          }),
          new ComboLeaf({
            id: 'weakPairAnd:oneOvercard',
            text: '&hellip;1 overcard',
            fullText: 'Weak pair and one overcard',
            isAHit: function (handInfo, drawInfo) {
              let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

              return handInfo.id === 'pair:weakPair' && oneOvercard;
            },
          }),
          new ComboLeaf({
            id: 'weakPairAnd:backdoorFlushDraw',
            text: '&hellip;<abbr title="Backdoor flush draw">bckdr fl dr</abbr>',
            fullText: 'Weak pair and backdoor flush draw',
            isAHit: function (handInfo, drawInfo) {
              let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

              return handInfo.id === 'pair:weakPair' && backdoorFlushDraw;
            },
          }),
          new ComboLeaf({
            id: 'weakPairAnd:backdoorStraightDraw',
            text: '&hellip;<abbr title="Backdoor straight draw">bckdr str dr</abbr>',
            fullText: 'Weak pair and backdoor straight draw',
            isAHit: function (handInfo, drawInfo) {
              let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

              return handInfo.id === 'pair:weakPair' && backdoorStraightDraw;
            },
          }),
        ],
      }),
      new ComboParent({
        id: 'flushDrawAnd',
        text: 'Flush draw and&hellip;',
        fullText: 'Flush draw and&hellip;',
        isAHit: function (handInfo, drawInfo) {
          let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
          let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
          let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
          let twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';
          let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
          let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

          return (
            flushDraw &&
            (eightOutStraightDraw || gutshot || twoOvercards || oneOvercard || backdoorStraightDraw)
          );
        },
        children: [
          new ComboLeaf({
            id: 'flushDrawAnd:eightOutStraightDraw',
            text: '&hellip;<abbr title="Eight out straight draw">8OSD</abbr>',
            fullText: 'Flush draw and eight out straight draw',
            isAHit: function (handInfo, drawInfo) {
              let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
              let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');

              return flushDraw && eightOutStraightDraw;
            },
          }),
          new ComboLeaf({
            id: 'flushDrawAnd:gutshot',
            text: '&hellip;gutshot',
            fullText: 'Flush draw and gutshot',
            isAHit: function (handInfo, drawInfo) {
              let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
              let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';

              return flushDraw && gutshot;
            },
          }),
          new ComboLeaf({
            id: 'flushDrawAnd:twoOvercards',
            text: '&hellip;2 overcards',
            fullText: 'Flush draw and two overcards',
            isAHit: function (handInfo, drawInfo) {
              let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
              let twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';

              return flushDraw && twoOvercards;
            },
          }),
          new ComboLeaf({
            id: 'flushDrawAnd:oneOvercard',
            text: '&hellip;1 overcard',
            fullText: 'Flush draw and one overcard',
            isAHit: function (handInfo, drawInfo) {
              let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
              let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

              return flushDraw && oneOvercard;
            },
          }),
          new ComboLeaf({
            id: 'flushDrawAnd:backdoorStraightDraw',
            text: '&hellip;<abbr title="Backdoor straight draw">bckdr str dr</abbr>',
            fullText: 'Flush draw and backdoor straight draw',
            isAHit: function (handInfo, drawInfo) {
              let flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
              let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

              return flushDraw && backdoorStraightDraw;
            },
          }),
        ],
      }),
      new ComboParent({
        id: 'eightOutStraightDrawAnd',
        text: '<abbr title="Eight out straight draw">8OSD</abbr> and&hellip;',
        fullText: '<abbr title="Eight out straight draw">8OSD</abbr> and&hellip;',
        isAHit: function (handInfo, drawInfo) {
          let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
          let twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';
          let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
          let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

          return (
            eightOutStraightDraw &&
            (twoOvercards || oneOvercard || backdoorFlushDraw)
          );
        },
        children: [
          new ComboLeaf({
            id: 'eightOutStraightDrawAnd:twoOvercards',
            text: '&hellip;2 overcards',
            fullText: 'Eight out straight draw and two overcards',
            isAHit: function (handInfo, drawInfo) {
              let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
              let twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';

              return eightOutStraightDraw && twoOvercards;
            },
          }),
          new ComboLeaf({
            id: 'eightOutStraightDrawAnd:oneOvercard',
            text: '&hellip;1 overcard',
            fullText: 'Eight out straight draw and one overcard',
            isAHit: function (handInfo, drawInfo) {
              let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
              let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

              return eightOutStraightDraw && oneOvercard;
            },
          }),
          new ComboLeaf({
            id: 'eightOutStraightDrawAnd:backdoorFlushDraw',
            text: '&hellip;<abbr title="Backdoor flush draw">bckdr fl dr</abbr>',
            fullText: 'Eight out straight draw and backdoor flush draw',
            isAHit: function (handInfo, drawInfo) {
              let eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
              let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

              return eightOutStraightDraw && backdoorFlushDraw;
            },
          }),
        ],
      }),
      new ComboParent({
        id: 'gutshotAnd',
        text: 'Gutshot and&hellip;',
        fullText: 'Gutshot and&hellip;',
        isAHit: function (handInfo, drawInfo) {
          let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
          let twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';
          let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
          let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

          return (
            gutshot &&
            (twoOvercards || oneOvercard || backdoorFlushDraw)
          );
        },
        children: [
          new ComboLeaf({
            id: 'gutshotAnd:twoOvercards',
            text: '&hellip;2 overcards',
            fullText: 'Gutshot and two overcards',
            isAHit: function (handInfo, drawInfo) {
              let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
              let twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';

              return gutshot && twoOvercards;
            },
          }),
          new ComboLeaf({
            id: 'gutshotAnd:oneOvercard',
            text: '&hellip;1 overcard',
            fullText: 'Gutshot and one overcard',
            isAHit: function (handInfo, drawInfo) {
              let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
              let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

              return gutshot && oneOvercard;
            },
          }),
          new ComboLeaf({
            id: 'gutshotAnd:backdoorFlushDraw',
            text: '&hellip;<abbr title="Backdoor flush draw">bckdr fl dr</abbr>',
            fullText: 'Gutshot and backdoor flush draw',
            isAHit: function (handInfo, drawInfo) {
              let gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
              let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

              return gutshot && backdoorFlushDraw;
            },
          }),
        ],
      }),
      new ComboParent({
        id: 'backdoorFlushDrawAnd',
        text: '<abbr title="Backdoor flush draw">Bckdr fl dr</abbr> and&hellip;',
        fullText: '<abbr title="Backdoor flush draw">Bckdr fl dr</abbr> and&hellip;',
        isAHit: function (handInfo, drawInfo) {
          let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
          let twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';
          let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
          let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

          return (
            backdoorFlushDraw &&
            (twoOvercards || oneOvercard || backdoorStraightDraw)
          );
        },
        children: [
          new ComboLeaf({
            id: 'backdoorFlushDrawAnd:twoOvercards',
            text: '&hellip;2 overcards',
            fullText: 'Backdoor flush draw and two overcards',
            isAHit: function (handInfo, drawInfo) {
              let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
              let twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';

              return backdoorFlushDraw && twoOvercards;
            },
          }),
          new ComboLeaf({
            id: 'backdoorFlushDrawAnd:oneOvercard',
            text: '&hellip;1 overcard',
            fullText: 'Backdoor flush draw and one overcard',
            isAHit: function (handInfo, drawInfo) {
              let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
              let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

              return backdoorFlushDraw && oneOvercard;
            },
          }),
          new ComboLeaf({
            id: 'backdoorFlushDrawAnd:backdoorStraightDraw',
            text: '&hellip;<abbr title="Backdoor straight draw">bckdr str dr</abbr>',
            fullText: 'Backdoor flush draw and backdoor straight draw',
            isAHit: function (handInfo, drawInfo) {
              let backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
              let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

              return backdoorFlushDraw && backdoorStraightDraw;
            },
          }),
        ],
      }),
      new ComboParent({
        id: 'backdoorStraightDrawAnd',
        text: '<abbr title="Backdoor straight draw">Bckdr str dr</abbr> and&hellip;',
        fullText: '<abbr title="Backdoor straight draw">Bckdr str dr</abbr> and&hellip;',
        isAHit: function (handInfo, drawInfo) {
          let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';
          let twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';
          let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

          return (
            backdoorStraightDraw &&
            (twoOvercards || oneOvercard)
          );
        },
        children: [
          new ComboLeaf({
            id: 'backdoorStraightDrawAnd:twoOvercards',
            text: '&hellip;2 overcards',
            fullText: 'Backdoor straight draw and two overcards',
            isAHit: function (handInfo, drawInfo) {
              let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';
              let twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';

              return backdoorStraightDraw && twoOvercards;
            },
          }),
          new ComboLeaf({
            id: 'backdoorStraightDrawAnd:oneOvercard',
            text: '&hellip;1 overcard',
            fullText: 'Backdoor straight draw and one overcard',
            isAHit: function (handInfo, drawInfo) {
              let backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';
              let oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

              return backdoorStraightDraw && oneOvercard;
            },
          }),
        ],
      }),
    ];
    super.setBreadcrumbText();
  };
};



// WEBPACK FOOTER //
// ./src/services/five-card-hands/categories/Combos.js